import PropTypes from 'prop-types';
import UIButton from 'UIComponents/button/UIButton';
import { jsx as _jsx } from "react/jsx-runtime";
const createUnstyledPluginButton = ({
  text
}) => {
  const UnstyledTextButton = ({
    onClick
  }) => {
    return /*#__PURE__*/_jsx(UIButton, {
      onClick: onClick,
      children: text
    });
  };
  UnstyledTextButton.propTypes = {
    onClick: PropTypes.func
  };
  return UnstyledTextButton;
};
export default createUnstyledPluginButton;